import { chatEE } from '@/layout/events/chat-event-emitter';
import { useEffect, useState } from 'react';
import type { Conversation } from '../models/conversation';

export const useConversationSetting = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [conversation, setConversation] = useState<Conversation | undefined>();

  useEffect(() => {
    const handleOpen = (conv: Conversation) => {
      setConversation(conv);
      setIsOpen(true);
    };

    chatEE.on('open-group-settings', handleOpen);

    return () => {
      chatEE.off('open-group-settings', handleOpen);
    };
  }, []);

  return {
    isOpen,
    conversation,
    closeDialog: () => {
      setIsOpen(false);
      setConversation(undefined);
    }
  };
};
